<style lang="scss">
button {
    -webkit-appearance: none;
    font-family: inherit;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #999999;
    padding: 8px 16px;
    letter-spacing: 0.01em;
    border: 1px solid #999;
    transition: opacity 0.2s;
    background: transparent;
    border-radius: 3px;
    cursor: pointer;

    &.primary {
        padding: 9px 32px;
        border: 0;
        color: #fff;
        background: #f977bd;
    }

    &[disabled] {
        cursor: default;
        opacity: 0.5;
    }
}

.label {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &.invisible {
        visibility: hidden;
    }

    :global(.progress) {
        visibility: visible;
        position: absolute !important;
        background: none !important;
        left: 50%;
        top: 50%;
        margin: -16px;
    }
}
</style>
<script context="module" type="ts">
export type ButtonRole = 'primary' | 'secondary';
</script>
<script lang="ts">
import Progress from './Progress.svelte';

export let role: ButtonRole = 'secondary';
export let type: string | undefined = undefined;
export let disabled: boolean | 'progress' = false;
</script>

<button {type} disabled={!!disabled} class:primary={role === 'primary'} on:click>
    <span class="label" class:invisible={disabled === 'progress'}>
        <slot></slot>
        {#if disabled === 'progress'}
            <Progress spin indeterminate />
        {/if}
    </span>
</button>
